import React from 'react';
import { useImage } from '../../context/ImageContext';
import MainCreate from '../MainCreate/MainCreate';
import MainEdit from '../MainEdit/MainEdit';


const Main = ({
    editUploadedImages,
    setEditUploadedImages,
    brushSize,
    eraserSize,
    activeButton,
    allCreateHistory,
    allEditHistory,
    setAllEditHistory,
    allBGHCreateHistory,
    createPageNumber,
    editPageNumber,
    setCreatePageNumber,
    setEditPageNumber,
    creditsAvailable,
    setCreditsAvailable,
    selectedEditGroup,
    setSelectedEditGroup,
    bghPageNumber,
    setBghPageNumber,
}) => {
    const { activeTab, setActiveTab } = useImage();

    return (
        <div className="flex-1 flex flex-col">
            <div className="flex-1">
                {activeTab === 'bgh' ? (
                    <MainCreate
                        editUploadedImages={editUploadedImages}
                        setEditUploadedImages={setEditUploadedImages}
                        allCreateHistory={allBGHCreateHistory}
                        allEditHistory={allEditHistory}
                        setAllEditHistory={setAllEditHistory}
                        createPageNumber={bghPageNumber}
                        setCreatePageNumber={setBghPageNumber}
                        setCreditsAvailable={setCreditsAvailable}
                        creditsAvailable={creditsAvailable}
                    />
                ) : activeTab === 'create' ? (
                    <MainCreate
                        editUploadedImages={editUploadedImages}
                        setEditUploadedImages={setEditUploadedImages}
                        allCreateHistory={allCreateHistory}
                        allEditHistory={allEditHistory}
                        setAllEditHistory={setAllEditHistory}
                        createPageNumber={createPageNumber}
                        setCreatePageNumber={setCreatePageNumber}
                        setCreditsAvailable={setCreditsAvailable}
                        creditsAvailable={creditsAvailable}
                    />
                ) : (
                    <MainEdit
                        editUploadedImages={editUploadedImages}
                        setEditUploadedImages={setEditUploadedImages}
                        brushSize={brushSize}
                        eraserSize={eraserSize}
                        activeButton={activeButton}
                        allEditHistory={allEditHistory}
                        setAllEditHistory={setAllEditHistory}
                        editPageNumber={editPageNumber}
                        setEditPageNumber={setEditPageNumber}
                        setCreditsAvailable={setCreditsAvailable}
                        selectedGroup={selectedEditGroup}
                        setSelectedGroup={setSelectedEditGroup}
                    />
                )}
            </div>
        </div>
    );
};

export default Main;
